import { createContext } from 'react';
export const UserInfoContext = /*#__PURE__*/createContext({
  gates: [],
  portal: {},
  user: {}
});